module.exports = __webpack_public_path__ + "static/img/wl@2x.aece3f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/wl@2x.png
// module id = MhKZ
// module chunks = 1